import * as cloudkeyzData from '../animations/cloudkeyz.json';

export const ROUTE = {
  base : '/',
};

export const MOBILE_RESOLUTION = 768;
export const PROCESS_STEPS = [
  {
    title       : 'Hit the books',
    description : 'Our process starts with understanding your brand, needs, business objectives, goals, and business objectives for your website. From this, we develop an appropriate timeline.',
    image       : 'process-step1.png',
  },
  {
    title       : 'Lay it out',
    description : 'We develop a sitemap and wireframe of your project to identify key features, functionalities, and structure of your website. Each factor works together to inform our design direction.',
    image       : 'process-step2.png',
  },
  {
    title       : 'Build a prototype',
    description : 'We design the graphics and visual elements needed to bring your website to life. Final design mock-ups are linked into the Interactive Prototype to offer hands-on experience before the product is even built.',
    image       : 'process-step3.png',
  },
  {
    title       : 'Bring it to life',
    description : 'From carefully thought out web design to customized website code, this is the stage when we bring your digital vision to life.',
    image       : 'process-step4.png',
  },
  {
    title       : 'Set it free',
    description : 'All our work leads up to this moment: our creation is finally ready to meet the world. Before each launch, we carefully inspect the website’s speed, security, and functionality to catch any issues before the website is live.',
    image       : 'process-step5.png',
  },
];

export const PROJECTS = [
  {
    tags     : 'Mobile App',
    name     : 'planeta',
    title    : 'Planeta Kino',
    subtitle : 'Mobile App for one of the biggest movie theater networks in Ukraine with remarkable minimalistic UI.',
    link     : '/planeta-kino',
    icon     : 'planeta-kino',
    // content  : '<video width="100%" height="100%" loop autoPlay muted playsInline class=\'-desktop\'>\n' +
    //   '                <source src="../../../../images/projects/planeta.webm" type="video/webm" preload="none"/>\n' +
    //   '                <source src="../../../../images/projects/planeta.mp4" type="video/mp4" preload="none"/>\n' +
    //   '            </video> <img src=\'../../../../images/projects/planeta.png\' alt=\'Image: company promo\' class=\'-mobile\'/>',
    content  : '<img src=\'../../../../images/projects/planeta.png\' alt=\'Image: company promo\'/>',
  },
  {
    tags     : 'Website / Web App / Mobile App',
    name     : 'onefile',
    title    : '1File',
    subtitle : 'Web & Mobile Platform that helps you organize multiple email accounts using machine learning algorithms.',
    link     : '/1file',
    icon     : 'onefile',
    // content  : '<video width="100%" height="100%" loop autoPlay muted playsInline class=\'-desktop\'>\n' +
    //   '                <source src="../../../../images/projects/onefile.webm" type="video/webm"  preload="none"/>\n' +
    //   '                <source src="../../../../images/projects/onefile.mp4" type="video/mp4"  preload="none"/>\n' +
    //   '            </video> <img src=\'../../../../images/projects/onefile.png\' alt=\'Image: company promo\' class=\'-mobile\'/>',
    content  : `
        <img src='../../../../images/projects/onefile.png' class='onefile-logo -mobile' alt='1File Project Image'/>
        <div class='onefile-logo-net-holder'>
            <img src='../../../../images/projects/onefile/onefile-net.png' alt='1File Project Image' class='onefile-logo-net'/>    
        </div>
        <img src='../../../../images/projects/onefile/onefile-coube.png' alt='1File Project Image' class='onefile-logo-coube'/>
    `,
  },
  {
    tags     : 'Website / Web App / Mobile App',
    name     : 'cloudkeyz',
    title    : 'CloudKeyz',
    subtitle : 'Hardware and software platform providing full control over the Common Area and Tenant Doors using Mobile App and KeyFobs.',
    link     : '/cloudkeyz',
    icon     : 'cloudkeyz',
    lottie   : {
      options : cloudkeyzData.default,
      height  : '100%',
      width   : '100%',
    },
    //content : "<div className='project-card__image-content'><Lottie options={lottieOptions} height='100%' width='100%'/></div>",
  },
  {
    tags        : 'Website',
    name        : 'viasat',
    title       : 'Viasat: AAA-Shows',
    subtitle    : 'Series of eye-catching, interactive websites for featured tv shows on Viasat network.',
    description : 'Series of eye-catching, interactive websites for featured tv shows on Viasat network.',
    link        : '/viasat',
    icon        : 'viasat',
    content     : '<img src=\'../../../../images/projects/viasat.png\' alt=\'Image: company promo\'/>',
  },
  {
    tags        : 'Mobile App',
    name        : 'motivetica',
    title       : 'Motivetica',
    subtitle    : 'Artistic application that gives you inspirational quotes from iconic designers in Helvetica that can be used as wallpapers.',
    description : 'Artistic application that gives you inspirational quotes from iconic designers in Helvetica that can be used as wallpapers.',
    link        : '/motivetica',
    icon        : 'motivetica',
    content     : '<img src=\'../../../../images/projects/motivetica.png\' alt=\'Image: company promo\'/>',
  },
  {
    tags        : 'Website',
    name        : 'vichy',
    title       : 'Vichy: Dermablend',
    subtitle    : 'Dermablend by Vichy, website provides an interactive tool for learning about the benefits of the product and its application.',
    description : 'Dermablend by Vichy, website provides an interactive tool for learning about the benefits of the product and its application.',
    link        : '/vichy',
    icon        : 'vichy',
    content     : '<img src=\'../../../../images/projects/vichy.png\' alt=\'Image: company promo\'/>',
  },
  {
    tags        : 'Website / Web App / Mobile App',
    name        : 'publbox',
    title       : 'PublBox',
    subtitle    : 'Social Media Management platform integrated with multiple social networks that allows you to create, post and track content for your business account.',
    description : 'Social Media Management platform integrated with multiple social networks that allows you to create, post and track content for your business account.',
    link        : '/publbox',
    icon        : 'publbox',
    content     : '<img src=\'../../../../images/projects/publbox.png\' alt=\'Image: company promo\'/>',
  },
  // {
  //   tags        : 'Website',
  //   name        : 'my-showdown',
  //   title       : 'MyShowdown',
  //   subtitle    : 'Conversation platform where users can create "showdowns" to settle debates, arguments, opinions and get real-time feedback from the community.',
  //   description : 'Conversation platform where users can create "showdowns" to settle debates, arguments, opinions and get real-time feedback from the community.',
  //   link        : '',
  //   icon        : 'my-showdown',
  //   content     : '<img src=\'../../../../images/projects/my-showdown.png\' alt=\'Image: company promo\'/>',
  // },
  {
    tags        : 'Website',
    name        : 'uvca',
    title       : 'UVCA',
    subtitle    : 'Corporate website for Ukrainian Venture Capital & Private Equity Association.',
    description : 'Corporate website for Ukrainian Venture Capital & Private Equity Association.',
    link        : '',
    icon        : 'uvca',
    content     : '<img src=\'../../../../images/projects/uvca.png\' alt=\'Image: company promo\'/>',
  },
  {
    tags        : 'Website',
    name        : 'aprise',
    title       : 'Aprise',
    subtitle    : 'Aprise matches your business with the government economic incentive programs, guide you through application process and makes application easy.',
    description : 'Aprise matches your business with the government economic incentive programs, guide you through application process and makes application easy.',
    link        : '',
    icon        : 'aprise',
    content     : '<img src=\'../../../../images/projects/aprise.png\' alt=\'Image: company promo\'/>',
  },
  {
    tags        : 'Website',
    name        : 'okean-elzy',
    title       : 'Okean Elzy 20 years ',
    subtitle    : 'Art Project OE20 is a virtual museum dedicated to the history of a famous rock band "Okean Elzy" where you can walk with your mobile phone.',
    description : 'Art Project OE20 is a virtual museum dedicated to the history of a famous rock band "Okean Elzy" where you can walk with your mobile phone.',
    link        : '',
    icon        : 'okean-elzy',
    content     : '<img src=\'../../../../images/projects/okean-elzy.png\' alt=\'Image: company promo\'/>',
  },
  {
    tags        : 'Website',
    name        : 'iq-bc',
    title       : 'IQ Business Center',
    subtitle    : 'Website for a Class A+ office building with detailed 3D map of the commercial and retail space.',
    description : 'Website for a Class A+ office building with detailed 3D map of the commercial and retail space.',
    link        : '',
    icon        : 'iq-bc',
    content     : '<img src=\'../../../../images/projects/iq-bc.png\' alt=\'Image: company promo\'/>',
  },
  // {
  //   tags        : 'Website / Web App / Mobile App',
  //   name        : 'pushsend',
  //   title       : 'PushSend',
  //   subtitle    : 'Pushsend is a universal marketing platform for creating email campaigns, events, and targeted web pages with a full-featured website & template editor.',
  //   description : 'Pushsend is a universal marketing platform for creating email campaigns, events, and targeted web pages with a full-featured website & template editor.',
  //   link        : '',
  //   icon        : 'pushsend',
  //   content     : '<img src=\'../../../../images/projects/pushsend.png\' alt=\'Image: company promo\'/>',
  // },
  {
    tags        : 'Website',
    name        : 'gtd',
    title       : 'Global Teacher Education',
    subtitle    : 'Online library and a knowledge center for educators to work on curriculums and discuss education issues.',
    description : 'Online library and a knowledge center for educators to work on curriculums and discuss education issues.',
    link        : '',
    icon        : 'gtd',
    content     : '<img src=\'../../../../images/projects/gtd.png\' alt=\'Image: company promo\'/>',
  },
  {
    tags     : 'Website',
    name     : 'milka',
    title    : 'Milka Letter of tenderness',
    subtitle : 'Promo website for a Swiss brand of chocolate that allowed to send personalized interactive post-cards to your friends and family for the New Year holidays.',
    link     : '',
    icon     : '',
    content  : '<img src=\'../../../../images/projects/milka.png\' alt=\'Image: company promo\' />',
  },
  {
    tags        : 'Website',
    name        : 'sphaeris',
    title       : 'Sphaeris',
    description : 'Corporate website for Capital Management conpany making proprietary private investments globally.',
    subtitle    : 'Corporate website for Capital Management conpany making proprietary private investments globally.',
    link        : '',
    icon        : 'sphaeris',
    content     : '<img src=\'../../../../images/projects/sphaeris.png\' alt=\'Image: company promo\'/>',
  },
];

export const BLOG_POSTS = [
  {
    id           : 1,
    title        : 'Startups',
    slug         : 'startups',
    lead         : 'Let’s hit the reality here at once: most entrepreneurs believe in their product as it is the next big thing. And with this belief in mind almost 91% of them fail.',
    author       : 'Alexandr Viniychuk',
    date         : '17 Aug 2019',
    previewImage : '/images/blog/startups.png',
    content      : '<p>\n' +
      '            Well, yes, the number is a bare statistics (but hey, isn’t it something we rely on?). It may vary from area of business or industry to the specific reason for a failure, but let’s agree that the number is impressive. 91% of products fail. And no one wants to be in that 91%.I am sure you and actually every single entrepreneur wants their product to shine brightly there on a market, receive remarkable reviews and tell everyone their success story. You want to become that new unicorn.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            But how to get to that point? How to avoid failure? What thinking to do and what actions to take to bring your product to the market and keep it alive there?\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            With so many options to fail in every business, there are surprisingly common ones for each and every field:\n' +
      '          </p>\n' +
      '\n' +
      '          <figure>\n' +
      '            <img src=\'../../../images/blog/startups.png\' alt=\'Image: 6 points to keep startup alive\'/>\n' +
      '            <figcaption>\n' +
      '              Actions to take to bring your product to the market and keep it alive there\n' +
      '            </figcaption>\n' +
      '          </figure>\n' +
      '          <p>\n' +
      '            The reason most common for failure is NO MARKET NEED. And in other words, customers simply don’t need you.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            Why? Well, let’s see:\n' +
      '          </p>\n' +
      '          <ul>\n' +
      '            <li>maybe you don’t solve any problems of your customers</li>\n' +
      '            <li>or maybe you just way too good and ahead of your time, that customers just don’t get you (yeah, sometimes it’s hard to be innovative)</li>\n' +
      '            <li>or maybe you did not show enough of the product’s value for people to want to buy it</li>\n' +
      '            <li>maybe you ignore your customers, or just don’t listen to them</li>\n' +
      '            <li>maybe you target audience is wrong due to some poor market research</li>\n' +
      '          </ul>\n' +
      '          <p>\n' +
      '            It can happen that you may find your own reason, but you definitely need to avoid at least those listed above. And to do so, you need to define your product; just give a nice and simple specification whether it is Vitamin (nice to have), or Aspirin (must have) on the market. And don’t try to cover the globe at once. You are at the start, your product is not ready yet, so don’t try to grab all the market you want. Start with your local market. And when the time comes you will be upscale. In other words, don’t try to do too much, too soon.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            And don’t ignore an old good friend - marketing research. It will lead you toward the understanding of the target audience and, as a result, a product that everyone wants.\n' +
      '          </p>\n' +
      '\n' +
      '          <h4>\n' +
      '            IGNORANCE OF CUSTOMER NEEDS\n' +
      '          </h4>\n' +
      '          <p>\n' +
      '            That is the issue that goes side to side with the previous one. The idea you have may be great. The product you are building is definitely great. But take a moment to think about who are you building it for? Who are those people, what needs do they have and how can you help THEM. Because with all the ideas and enthusiasm for building the next big thing, it is easy to get tunnel vision. And that can lead only for you spending too much of the precious time on building the product for yourself. You must consider the feedback from your potential clients and adapt to their needs.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            Talk to your potential customers. Like really, constantly be in touch with them: interview them, quiz, feel their pain and listen to proposals (seriously, you may even get an idea for a new start up by communicating with your clients). And that will definitely save you some long hours of brainstorming. Including one other little bonus you can have: by the release time you will already have some customers waiting on you.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            Yes, it is hard to just explain the idea and hear the feedback (that won’t do a job, seriously). And to put all the effort and wait on the Beta is also a sleazy path to go by. What you need is to start with MVP development. It will save you money (and we will talk about how you\'re gonna need them) , but the main thing is that it will show you your product in action and will allow you to get those first customers reviews you need.\n' +
      '          </p>\n' +
      '\n' +
      '          <h4>\n' +
      '            Time to take a PIVOT\n' +
      '          </h4>\n' +
      '          <p>\n' +
      '            In order to survive in the competitive business world you need to foresee the possible changes and to adapt.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            Pivot is not a mistake you make, that is actually something to be a mistake not to do when the time comes. Being a startup means you basically testing your idea, your product, your business model. And what can happen is that\n' +
      '          </p>\n' +
      '          <ul>\n' +
      '            <li>another company will release a similar product</li>\n' +
      '            <li>the audience you were referring to as your customers is not interested in your product</li>\n' +
      '            <li>or they are not ready to pay you as they have no trust in your startup</li>\n' +
      '            <li>the audience is not growing or maybe you’re even losing some</li>\n' +
      '            <li>the development is too expensive</li>\n' +
      '          </ul>\n' +
      '          <p>\n' +
      '            So now you need to slightly change your idea, product, business plan. Or maybe you need that change to even take a dramatic turn.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            Give it some time, overthink and pivot.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            Pivot is one of the fundamental concepts of Lean Startup methodology suggested by Eric Ries (you know who he is, right?). Pivot means a change of direction for your product and giving it a new twist after receiving first feedback; a shift you do in your strategy to test new business model approach.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            You know, many successful startups had to take a pivot. For example, Instagram: initially it was called Burbn and had too many functions including location-based check-ins, planning meetings and sharing photos from those meetings. But it turned out that no one was actually interested in planning or in check-ins, but a quick share of a photo was appealing to first users. And so then they pivoted and we all know the result it had.\n' +
      '          </p>\n' +
      '\n' +
      '          <h4>\n' +
      '            PEOPLE and culture of the company (THE team)\n' +
      '          </h4>\n' +
      '          <p>\n' +
      '            Unless you are a pro in head-hunting people, who are eager to change the world at no cost you may find the issues within your own team.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            First thing, you need to have good technical experts in your team at the very beginning. Don\'t try to save some pennies here. Otherwise you may get a low-quality product that no one will want to use.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            Another thing, you should constantly share your vision for the product with the team. New approaches and details, new twists and turns or simple updates on the progress - those should be shared with the team in order for everyone to feel that movement and get a regular motivagion dose (shot).\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            And though your priority should be people who actually do the work, you also should think about your management team. Thus your process will be organized and your development team will always know the priorities, the timing and in general what the company needs\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            And don\'t forget about yourself and your co-founders, if you lack the skills and abilities to get your company going - educate yourself or hire someone to cover the gaps.\n' +
      '          </p>\n' +
      '\n' +
      '          <h4>\n' +
      '            POOR SALES AND MARKETING\n' +
      '          </h4>\n' +
      '          <p>\n' +
      '            No matter how good your product is, it won\'t get itself on a market on its own. And customers won\'t beat a path to your door with no good reason for that.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            In the real world it\'s not that easy to acquire customers. You need to actually win the attention and introduce your product to that potential and demanding market. Even though you don\'t need to hire a professional PR team, your marketing should definitely be at a high level. Spread the world in social media, publish articles in the magazines and online resources that are interesting to your audience. You need to reach your audience by all means possible, because if no one knows about your product - no one will buy it.\n' +
      '          </p>\n' +
      '\n' +
      '          <h4>\n' +
      '            MONEY\n' +
      '          </h4>\n' +
      '          <p>\n' +
      '            A simple and unfortunate reason when you just run out of cash. It can happen while you’re still in the mid-process of building your product or when it was already launched.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            And the reasons can vary and to name the few:\n' +
      '          </p>\n' +
      '          <ul>\n' +
      '            <li>your were underfunded or lack of investor interest</li>\n' +
      '            <li>or got a bit overwhelmed and spent money recklessly (new fancy office for example)</li>\n' +
      '            <li>tried to scale up too early</li>\n' +
      '            <li>or simple failed to achieve the next milestone</li>\n' +
      '          </ul>\n' +
      '\n' +
      '          <p>\n' +
      '            So what you need to do first is to build a business model. And that business mode of yours should account for all costs: the required technology stack, the team to work on the product, the marketing strategy, and don’t forget to include methods of monetization.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            And the thing to keep in mind: even if you raised your Series A round extremely well, try to spend as little money as possible. And it is not about being greedy. Just don’t put everything out there. Hire people you actually need, having in mind that a devoted team sometimes pays better than (self-)proclaimed tech-stars. Find ways to reduce cost for the office, transportation and delivery services, if any. Don’t spend it all on marketing, especially by the means of development - highly advertised product without the ability to actually launch not something you want to end up with.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            And the main thing: don’t try to build it all and even more at once. Nice-to-have features should be kept for the stage 2 and 3 of development. You need to have the core. Start with MVP and see how it goes.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            It is not easy to build your product in a highly competitive world right now. But you need to remember that in the end it is all about the people - the people inside the organization (your team) and the people outside it (customers).\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            Believe in your ideas and that you and your team can make them real.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            Believe that you can change the lives of people with your product, or at least make it easier by solving their problems.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            Be aware of the mistakes you can so easily avoid.\n' +
      '          </p>\n' +
      '          <p>\n' +
      '            Good Luck! And let’s roll!\n' +
      '          </p>',
  },
  {
    id           : 2,
    title        : 'Five vices of the team',
    slug         : 'five-vices-of-the-team',
    lead         : 'Five vices of the team lead',
    author       : 'Natalie Khadzhyoglo',
    date         : '21 Dec 2019',
    previewImage : '/images/home-blog.jpg',
    content      : '<p>Well, yes, the number is a bare statistics (but hey, isn’t it <a href=\'#\' class=\'link\'>something we rely on</a>?). It may vary from area of business or industry to the specific reason for a failure, but let’s agree that <strong>the number is impressive</strong>. 91% of products fail. And no one wants to be in that 91%.I am sure you and actually every single entrepreneur wants their product to shine brightly there on a market, <em>receive remarkable reviews</em> and tell everyone their success story. You want to become that new unicorn.</p><figure><img src=\'../../../images/blog/startups.png\' alt=\'Image: 6 points to keep startup alive\'/><figcaption>Actions to take to bring your product to the market and keep it alive there</figcaption></figure><p>The reason most common for failure is NO MARKET NEED. And in other words, customers simply don’t need you.</p><p>Why? Well, let’s see:</p><ol><li>maybe you don’t solve any problems of your customers</li><li>or maybe you just way too good and ahead of your time, that customers just don’t get you (yeah, sometimes it’s hard to be innovative)</li><li>or maybe you did not show enough of the product’s value for people to want to buy it</li><li>maybe you ignore your customers, or just don’t listen to them</li><li>maybe you target audience is wrong due to some poor market research</li></ol><p>It can happen that you may find your own reason, but you definitely need to avoid at least those listed above. And to do so, you need to define your product; just give a nice and simple specification whether it is Vitamin (nice to have), or Aspirin (must have) on the market. And don’t try to cover the globe at once. You are at the start, your product is not ready yet, so don’t try to grab all the market you want. Start with your local market. And when the time comes you will be upscale. In other words, don’t try to do too much, too soon.</p><ul><li>your were underfunded or lack of investor interest</li><li>or got a bit overwhelmed and spent money recklessly (new fancy office for example)</li><li>tried to scale up too early</li><li>or simple failed to achieve the next milestone</li></ul><p>And the thing to keep in mind: even if you raised your Series A round extremely well, try to spend as little money as possible. And it is not about being greedy. Just don’t put everything out there. Hire people you actually need, having in mind that a devoted team sometimes pays better than (self-)proclaimed tech-stars. Find ways to reduce cost for the office, transportation and delivery services, if any. Don’t spend it all on marketing, especially by the means of development - highly advertised product without the ability to actually launch not something you want to end up with.</p><blockquote class=\'blockquote\'><p class=\'blockquote__text\'>And the main thing: don’t try to build it all and even more at once. Nice-to-have features should be kept for the stage 2 and 3 of development. You need to have the core. Start with MVP and see how it goes.</p><p class=\'blockquote__author-name\'>Alexandr Viniychuk,</p><p class=\'blockquote__author-position\'>CEO Youshido</p></blockquote><p>It is not easy to build your product in a highly competitive world right now. But you need to remember that in the end it is all about the people - the people inside the organization (your team) and the people outside it (customers).</p>',
  },
  {
    id           : 3,
    title        : 'Life of Hooks',
    slug         : 'exiting-life-of-hooks',
    lead         : 'Google knows',
    author       : 'John Doe',
    date         : '08 Feb 2020',
    previewImage : '/images/home-about.jpg',
    content      : 'Test content 3',
  },
];
